import React from "react"
import News from "../../../blocks/en/news_page"
import { Link, graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "rodic_signs_with_riga" }) {
    ...NewsInfoEn
  }
}`

export default class NewsTextEn extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Fitness coach Nikola Rodic from Northern Macedonia has signed a contract with FC Riga, where he will work as the head coach for physical training for all ages in the academy of FC Riga.</p>
        </div>
      </div>
    )
  }
}